(function() {
    'use strict';

    angular.module('caffeprint')
        .controller('TopnavbarController', TopnavbarController);

    TopnavbarController.$inject = ['userAuthService'];

    function TopnavbarController(userAuthService) {
        var self = this;

        self.logout = userAuthService.logout;
    }
})();
